"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deviceRawLogSchema = exports.deviceOnboardingSchema = exports.deviceRecordSchema = exports.deviceRecommendationSchema = exports.updateDeviceConfigSchema = exports.registerDeviceSchema = exports.deviceSimSchema = exports.deviceIdPattern = void 0;
const zod_1 = require("zod");
const vehicles_1 = require("./vehicles");
exports.deviceIdPattern = /^imei:[0-9]{15}$|^[A-Za-z0-9:_-]+$/;
exports.deviceSimSchema = zod_1.z
    .object({
    iccid: zod_1.z.string().optional(),
    imsi: zod_1.z.string().optional(),
})
    .strict();
exports.registerDeviceSchema = zod_1.z
    .object({
    deviceId: zod_1.z.string().regex(exports.deviceIdPattern),
    model: zod_1.z.string(),
    firmware: zod_1.z.string().optional(),
    sim: exports.deviceSimSchema.optional(),
    configProfileId: zod_1.z.string().optional(),
})
    .strict();
exports.updateDeviceConfigSchema = zod_1.z
    .object({
    mode: zod_1.z.enum(["live", "periodic", "buffered", "eco", "event"]).optional(),
    intervalSec: zod_1.z.number().int().min(1).optional(),
    otaChannel: zod_1.z.enum(["stable", "beta"]).optional(),
})
    .strict();
exports.deviceRecommendationSchema = zod_1.z.object({
    mode: zod_1.z.string(),
    interval_seconds: zod_1.z.number().int(),
    ota_channel: zod_1.z.string(),
    rationale: zod_1.z.string(),
    parser_template: zod_1.z.string().nullable().optional(),
});
exports.deviceRecordSchema = exports.registerDeviceSchema
    .omit({ firmware: true, sim: true })
    .extend({
    firmware: zod_1.z.string().optional(),
    sim: exports.deviceSimSchema.optional(),
    config: exports.updateDeviceConfigSchema.optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
    number: zod_1.z.string().optional(),
    name: zod_1.z.string().optional(),
    status: zod_1.z.string().optional(),
    lastPing: zod_1.z.string().optional(),
    location: vehicles_1.vehicleLocationSchema.optional(),
    driver: vehicles_1.vehicleDriverSchema.optional(),
    sensors: vehicles_1.vehicleSensorSchema.optional(),
    flags: vehicles_1.vehicleFlagsSchema.optional(),
    media: vehicles_1.vehicleMediaSchema.optional(),
    imei: zod_1.z.string().optional(),
    lastSignalAt: zod_1.z.string().optional(),
});
exports.deviceOnboardingSchema = zod_1.z.object({
    id: zod_1.z.string(),
    imei: zod_1.z.string(),
    name: zod_1.z.string().nullable().optional(),
    serial: zod_1.z.string().nullable().optional(),
    iccid: zod_1.z.string().nullable().optional(),
    protocol: zod_1.z.string(),
    parserTemplate: zod_1.z.string(),
    apn: zod_1.z.string().nullable().optional(),
    heartbeat: zod_1.z.number().nullable().optional(),
    status: zod_1.z.string(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).nullable().optional(),
    autoProvision: zod_1.z.boolean().optional(),
    assignedVehicleId: zod_1.z.string().nullable().optional(),
    lastSignalAt: zod_1.z.string().nullable().optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
    recommendation: exports.deviceRecommendationSchema.nullable().optional(),
});
exports.deviceRawLogSchema = zod_1.z.object({
    id: zod_1.z.string(),
    tag: zod_1.z.string(),
    receivedAt: zod_1.z.string(),
    payload: zod_1.z.string(),
    remote: zod_1.z
        .union([
        zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
        zod_1.z.array(zod_1.z.unknown()),
        zod_1.z.string(),
        zod_1.z.null(),
    ])
        .optional(),
    device: zod_1.z.object({
        imei: zod_1.z.string().optional(),
    }),
});
